"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZillowLogo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ZillowLogo = require("./ZillowLogo.styles");
var _excluded = ["removeTrademark"];
/**
 * @since 7.23.0
 */
var ZillowLogo = function ZillowLogo(_ref) {
  var removeTrademark = _ref.removeTrademark,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var trademark;
  if (!removeTrademark) {
    trademark = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1895.2 113.9c0-7-4.9-12-11.7-12H1871v34h5.6v-10.1h5.5l6.2 10.2h6.4l-6.7-11c4.3-1.7 7.2-5.8 7.2-11.1zm-12 6.9h-6.6V107h6.6c3.7 0 6.4 3 6.4 7s-2.7 6.8-6.4 6.8z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M1881.8 90.2a29.4 29.4 0 1 0 29.4 29.3 29.4 29.4 0 0 0-29.4-29.3zm0 53a23.7 23.7 0 1 1 23.8-23.7 23.8 23.8 0 0 1-23.8 23.8z"
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_ZillowLogo.StyledZillowLogo, (0, _extends2.default)({
    viewBox: "0 0 " + (removeTrademark ? 1843 : 1911) + " 400"
  }, rest), /*#__PURE__*/_react.default.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1460.4 148.6h77.8l22.5 73.7c7.5 24.4 20.1 70.2 20.1 70.2a.6.6 0 0 0 1.1 0s13-46.7 20.5-70.2l23.6-73.7h57.4l23.3 73.7c7.8 25.2 20 70.2 20 70.2a.6.6 0 0 0 1.1 0s12.7-45.6 20-70.2l22.6-73.7h72.3L1764.5 392h-71.1l-19.4-61c-7.5-24-20.6-70.6-20.6-70.6a.6.6 0 0 0-1.1 0s-13.1 45.7-21 70.2l-19.7 61.6h-72.4zM936.8 19.9h78.7v372.2h-78.7zM1073.8 19.9h78.7v372.2h-78.7zM1380.7 271.2c0-36.3-25.9-61-56.5-61-31.3 0-57.2 24.7-57.2 61 0 36.5 25.9 60.9 57.2 60.9 30.6 0 56.5-24.4 56.5-61m-189.2 0c0-74 59.7-128.7 132.7-128.7 72.3 0 132 54.8 132 128.8 0 74.2-59.7 129-132 129-73 0-132.7-54.8-132.7-129M481.5 54.4V126h139c.7 0 .9.5.6 1L481.4 364.5c-3.4 6.2-4.2 7.5-4.2 13.6v14h271v-71.6H597.7a.6.6 0 0 1-.5-1L738.5 79c1.1-2.3 2.3-4 2.3-9.6v-15zM798.4 148.6H877V392h-78.7zm39.3-122c24.6 0 44.8 19.8 44.8 44.2S862.3 115 837.7 115 793 95.2 793 70.8s20.3-44.2 44.8-44.2 "
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M242.2 106.3c1.8-.4 2.6.2 3.7 1.4 6.1 7 26 31.1 31.4 37.7a2.1 2.1 0 0 1-.5 3.2 714.8 714.8 0 0 0-109.3 107c-.5.6-.1.7.2.5 43.3-18.6 144.7-48.2 190.5-56.6v-57.9L179.2.2.2 141.6V205c55.5-33 183.9-84.1 242-98.6z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M96.6 349.5a3 3 0 0 1-3.8-.6l-33.5-39.8c-.9-1-1-1.6.2-3.4C85.3 268 138 209 171.5 184.1c.7-.5.5-1-.2-.7C136.3 195 37 237.6 0 258.4v135.2h358.2V263.5c-49 8.3-195.1 51.8-261.6 86z"
  }), trademark));
};
exports.ZillowLogo = ZillowLogo;
ZillowLogo.displayName = 'ZillowLogo';
ZillowLogo.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The token color of the logo.
   */
  fontColor: _propTypes.default.string,
  /**
   * Zillow logos should **always include the trademark** unless you verify with the brand team
   * that it can be removed.
   */
  removeTrademark: _propTypes.default.bool
} : {};
ZillowLogo.defaultProps = {
  fontColor: 'brand',
  removeTrademark: false
};